import React from "react";
import {
  completeNull,
  modalidadCateogoriaNameByCode,
  calcularEdad,
} from "../../../../../services/utils";
import { cambiarModGenCatFB } from "../../../../../firebase/firebasejs";
import { buscarCategoria, validarEdadEnCategoria } from "../participantValidationLogic";
import ValidationAlertButton from "./ValidationAlertButton";
import FormRender from "../../../../Fields/FormRender";
import { Grid, Box } from "@material-ui/core";

class ModCatGenDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editable: true,
      editing: false,
      ModCatGenDetailJSON: {
        modalidad: null,
        genero: null,
        categoria: null,
        statusPago: null,
        eventoIndex: null,
        idRegistro: null,
        modalidadAnterior: null,
        generoAnterior: null,
        categoriaAnterior: null,
      },
    };
  }

  cambiarModGenCat = (data) => {
    console.log("Cambio MODCATGEN");
    var valorSplit = data.valor.split("-#%&");
    var ModCatGenDetailJSON = {};
    ModCatGenDetailJSON.modalidad = valorSplit[0];
    ModCatGenDetailJSON.genero = valorSplit[1];
    ModCatGenDetailJSON.categoria = valorSplit[2];
    ModCatGenDetailJSON.statusPago = valorSplit[3];
    ModCatGenDetailJSON.eventoIndex = valorSplit[4];
    ModCatGenDetailJSON.idRegistro = valorSplit[5];

    ModCatGenDetailJSON.modalidadAnterior = valorSplit[6];
    ModCatGenDetailJSON.generoAnterior = valorSplit[7];
    ModCatGenDetailJSON.categoriaAnterior = valorSplit[8];

    var eventoIndex = "evento_" + this.props.eventDetail.iDEvento;
    cambiarModGenCatFB(
      this.props.eventSubEventsRegistry,
      ModCatGenDetailJSON,
      eventoIndex,
      this.props.ParticipantDetailKey,
      this.props.ParticipantDetail,
      this.props.userID,
      this.props.atleteAccount
    );
    this.toogleEditing();
  };

  editarModalidadRamaCategoria = (
    eventSubEventsRegistry,
    modalidad,
    Genero,
    categoria,
    statusPago,
    eventoIndex,
    idRegistro
  ) => {
    var modCatJson = modalidadCateogoriaNameByCode(
      eventSubEventsRegistry,
      modalidad,
      categoria,
      Genero
    );
    console.log(JSON.stringify(modCatJson));

    var opcionesSelect = [];
    var ModalidadesEvento = eventSubEventsRegistry;
    var precioKey = "";
    var anteriorMod = false;
    var anteriorRama = false;

    var espacio = " ";

    var modalidadTexto = "";
    var generoTexto = "";
    var categoriaTexto = "";
    var codMod = 0;
    var codCat = "";
    var codGen = "";

    for (var i in ModalidadesEvento) {
      codMod = ModalidadesEvento[i].codigoModalidad;
      anteriorMod = false;
      modalidadTexto = `Evento: ${ModalidadesEvento[i].descripcionModalidad}`;
      if (ModalidadesEvento[i].codigoModalidad == modalidad) {
        anteriorMod = true;
      }
      var ramaCategoria = ModalidadesEvento[i].ramaCat;
      for (var e in ramaCategoria) {
        anteriorRama = false;
        if (e.localeCompare("rama_F") == 0) {
          generoTexto = "Rama Femenil";
          codGen = "F";
        } else {
          generoTexto = "Rama Varonil";
          codGen = "V";
        }
        if (e.localeCompare("rama_" + Genero) == 0 && anteriorMod) {
          anteriorRama = true;
        }
        var categorias = ramaCategoria[e].categorias;
        for (var f in categorias) {
          codCat = categorias[f].codigo;
          categoriaTexto = `${modalidadTexto} ${generoTexto} Categoria ${categorias[f].nombreCategoria}`;
          if (!categorias[f].absolutos) {
            if (
              categorias[f].codigo == categoria &&
              anteriorMod &&
              anteriorRama
            ) {
              opcionesSelect.push({
                label: `${espacio.repeat(0)} ${categoriaTexto} (Previa)`,
                value: `${codMod}-#%&${codGen}-#%&${codCat}-#%&${statusPago}-#%&${eventoIndex}-#%&${idRegistro}-#%&${modalidad}-#%&${Genero}-#%&${categoria}`,
              });
              precioKey = categorias[f].precioKey;
            } else {
              opcionesSelect.push({
                label: `${espacio.repeat(0)} ${categoriaTexto}`,
                value: `${codMod}-#%&${codGen}-#%&${codCat}-#%&${statusPago}-#%&${eventoIndex}-#%&${idRegistro}-#%&${modalidad}-#%&${Genero}-#%&${categoria}`,
              });
            }
          }
        }
      }
    }

    const filterSelect = {
      filter: {
        label: "Selecciona la opción corresponiente",
        errorMessage: "Campo Requerido",
        fieldName: "valor",
        type: "select",
        defaultValue: 1,
        required: true,
        regex: "",
        textSize: "h6",
        optionsArray: opcionesSelect,
      },
    };

    return (
      <Grid container spacing={0}>
        <Grid item xs={10}>
          <FormRender
            callback={this.cambiarModGenCat}
            formObject={filterSelect}
            submitButtonText={"Guardar Cambio"}
          />
        </Grid>
      </Grid>
    );
  };

  toogleEditing = () => {
    this.setState({
      editing: !this.state.editing,
    });
  };

  render() {
    const modalidad = this.props.ParticipantDetail.modalidad;
    const categoria = this.props.ParticipantDetail.categoria;
    const genero = this.props.ParticipantDetail.rama;
    const modCatJson = modalidadCateogoriaNameByCode(
      this.props.eventSubEventsRegistry,
      modalidad,
      categoria,
      genero
    );
    const statusPago = this.props.ParticipantDetail.statusPago.status;
    var eventoIndex = "evento_" + this.props.eventDetail.iDEvento;

    // Edad a efectos del evento (misma regla que la descarga de Excel) vs.
    // el rango de edad de la categoría elegida — solo informa, no bloquea.
    const edadConfig =
      this.props.registryConfiguration &&
      this.props.registryConfiguration.configuracion &&
      this.props.registryConfiguration.configuracion.edadActual;
    const edadEvento = calcularEdad(
      this.props.ParticipantDetail.fechaNacimiento,
      this.props.eventDetail.fechaEvento,
      edadConfig
    );
    const categoriaObj = buscarCategoria(this.props.eventSubEventsRegistry, modalidad, genero, categoria);
    const validacionEdad = validarEdadEnCategoria(edadEvento, categoriaObj);

    let tabla;
    if (this.state.editing && this.state.editable) {
      tabla = this.editarModalidadRamaCategoria(
        this.props.eventSubEventsRegistry,
        modalidad,
        genero,
        categoria,
        statusPago,
        eventoIndex,
        this.props.ParticipantDetailKey
      );
    } else {
      tabla = (
        <Box p={1} onClick={() => this.toogleEditing()}>
          <Grid container>
            <Grid item xs={3}>
              <Box
                p={10}
                style={{
                  backgroundColor: "#f44336",
                  color: "white",
                  textAlign: "center",
                }}
              >
                <b>Modalidad </b>
                <br />
                {modCatJson.modalidad}
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Box
                p={10}
                style={{
                  backgroundColor: "#f44336",
                  color: "white",
                  textAlign: "center",
                }}
              >
                <b>Rama </b>
                <br />
                {genero}
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Box
                p={10}
                style={{
                  backgroundColor: "#f44336",
                  color: "white",
                  textAlign: "center",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                }}
              >
                <div>
                  <b>Categoría </b>
                  <br />
                  {modCatJson.categoria}
                </div>
                {!validacionEdad.valido && (
                  <div onClick={(e) => e.stopPropagation()}>
                    <ValidationAlertButton mensaje={validacionEdad.mensaje} claro />
                  </div>
                )}
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Box
                p={10}
                style={{
                  backgroundColor: "#f44336",
                  color: "white",
                  textAlign: "center",
                }}
              >
                <b>Status pago </b>
                <br />
                {statusPago}
              </Box>
            </Grid>
          </Grid>
        </Box>
      );
    }
    return tabla;
  }
}

export default ModCatGenDetail;
